(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-second-section"] && !Shopify.designMode) return;
  try {
    
  
   $('.show-more').click(function(e) {
        e.preventDefault();
        $(this).text(function(i, t) {
          return t == 'Show less ...' ? 'Show more ...' : 'Show less ...';
        }).prev('.complete-text').slideToggle()
      });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestseller-slider"] && !Shopify.designMode) return;
  try {
      
     $('.bestsellerslider').owlCarousel({      
          nav: true, 
          navText: ["<img src='https://cdn.shopify.com/s/files/1/1002/0080/files/prev-arrow-bestseller.png'>","<img src='https://cdn.shopify.com/s/files/1/1002/0080/files/next-arrow-bestseller.png'>"], 
          margin: 32,  
          dots: false,  
          items: 4,        
          loop: false,   
          autoplay: false, 
          responsiveClass: true, 
          responsive: {   
              0: { 
                  items: 1, 
                  loop: true,
                  stagePadding: 20         
              },  
              570: { 
                  items: 2,
                  loop: true,
                  stagePadding: 20     
              },    
              767: { 
                  items: 3,
                  stagePadding: 60      
              },  
              1200: {  
                  items: 4,
                  stagePadding: 100 
              }
          }
        });         
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-testimonials"] && !Shopify.designMode) return;
  try {
    
  
  $('.show-more').click(function(e) {
        e.preventDefault();
        $(this).text(function(i, t) {
          return t == 'Show less ...' ? 'Show more ...' : 'Show less ...';
        }).prev('.complete-text').slideToggle()
      });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ssp-lens-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ssp-lens-explorer')) {
  customElements.define('ssp-lens-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._events = new AbortController();
      queueMicrotask(() => {
        if (this.isConnected && this._events && !this._range) this._initialize();
      });
    }

    disconnectedCallback() {
      this._events?.abort();
      this._images?.abort();
      this._initialImages?.abort();
      this._appearanceImages?.abort();
      this._request = (this._request || 0) + 1;
      this._events = null;
      this._range = null;
      this.removeAttribute('data-ready');
    }

    _initialize() {
      this._stage = this.querySelector('[data-le-stage]');
      this._range = this.querySelector('input[type="range"][data-le-range]');
      this._original = this.querySelector('[data-le-original-image]');
      this._tinted = this.querySelector('[data-le-tinted-image]');
      if (!this._stage || !this._range || !this._original || !this._tinted) return;

      this._modes = [...this.querySelectorAll('button[data-le-mode]')];
      this._lenses = [...this.querySelectorAll('button[data-le-lens]')];
      this._lensSelect = this.querySelector('select[data-le-lens-select]');
      this._lensOptions = [...(this._lensSelect?.querySelectorAll('option[data-le-lens]') || [])];
      this._kits = [...this.querySelectorAll('[data-le-kit][data-kit]')];
      this._appearanceSlot = this.querySelector('[data-le-appearance-slot]');
      this._appearanceTemplates = [...this.querySelectorAll('template[data-le-appearance-template]')];
      this._appearanceStatus = this.querySelector('[data-le-appearance-status]');
      this._scenes = [...this.querySelectorAll('button[data-le-scene]')];
      this._status = this.querySelector('[data-le-status]');
      this._status?.setAttribute('role', 'status');
      this._status?.setAttribute('aria-live', 'polite');
      this._status?.setAttribute('aria-atomic', 'true');
      this._range.min = '0';
      this._range.max = '100';
      this._range.step = '1';
      this._split = this._interiorSplit(this._split ?? this._range.value);
      this._activeScene = this._scenes.find(button => button.getAttribute('aria-pressed') === 'true') || this._scenes[0];
      this._hasImage = false;
      this._sceneLoading = false;
      this._busy(false);
      const options = { signal: this._events.signal };

      this._range.addEventListener('input', () => {
        this.dataset.interacted = 'true';
        this._setRange(this._range.value);
      }, options);
      this._range.addEventListener('pointerdown', () => { this.dataset.interacted = 'true'; }, options);
      this._modes.forEach(button => button.addEventListener('click', () => {
        this.dataset.interacted = 'true';
        this._setMode(button.dataset.leMode);
      }, options));
      this._lenses.forEach(button => button.addEventListener('click', () => this._setLens(button), options));
      this._lensSelect?.addEventListener('change', () => {
        this._setLens(this._lensSelect.selectedOptions[0]);
      }, options);
      this._scenes.forEach(button => button.addEventListener('click', () => this._setScene(button), options));

      const selectedMode = this._modes.find(button => button.getAttribute('aria-pressed') === 'true');
      this._setMode(this._mode || selectedMode?.dataset.leMode || 'split');
      this._setLens(this._lensSelect?.selectedOptions[0] || this._lensOptions[0]
        || this._lenses.find(button => button.getAttribute('aria-pressed') === 'true') || this._lenses[0]);
      this.dataset.ready = 'true';
      this._checkInitialImages();
    }

    _percentage(value) {
      const number = Number(value);
      return Number.isFinite(number) ? Math.min(100, Math.max(0, Math.round(number))) : 50;
    }

    _interiorSplit(value) {
      const split = this._percentage(value);
      return split > 0 && split < 100 ? split : 50;
    }

    _setRange(value) {
      const split = this._percentage(value);
      if (split > 0 && split < 100) this._split = split;
      this._setMode(split === 0 ? 'tint' : split === 100 ? 'original' : 'split');
    }

    _setMode(mode) {
      if (!['original', 'split', 'tint'].includes(mode)) return;
      this._mode = mode;
      this._split = this._interiorSplit(this._split);
      const split = mode === 'original' ? 100 : mode === 'tint' ? 0 : this._split;
      this.style.setProperty('--split', `${split}%`);
      this.dataset.mode = mode;
      this.dataset.view = split === 100 ? 'original' : split === 0 ? 'tint' : 'split';
      this._range.value = String(split);
      this._modes.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.leMode === mode)));
      const valueText = split === 100 && this.dataset.rangeOriginalText
        ? this.dataset.rangeOriginalText
        : split === 0 && this.dataset.rangeTintText
          ? this.dataset.rangeTintText
          : this.dataset.rangeValueText || '{original}%';
      this._range.setAttribute('aria-valuetext', valueText
        .replaceAll('{original}', String(split))
        .replaceAll('{tint}', String(100 - split))
        .replaceAll('{lens}', this._lensLabel || ''));
    }

    _setLens(selected) {
      if (!selected) return;
      const color = selected.dataset.color || '';
      const opacity = Number(selected.dataset.opacity);
      if (!/^#(?:[\da-f]{3}|[\da-f]{6})$/i.test(color) || !Number.isFinite(opacity)) return;
      this.style.setProperty('--tint', color);
      this.style.setProperty('--tint-opacity', String(Math.min(1, Math.max(0, opacity))));
      this._lensLabel = selected.dataset.label || '';
      this._setText('[data-le-lens-name]', this._lensLabel);
      this._setText('[data-le-note]', selected.dataset.note || '');
      const matches = lens => lens === selected || Boolean(selected.dataset.leLens
        && lens.dataset.leLens === selected.dataset.leLens);
      this._lenses.forEach(lens => lens.setAttribute('aria-pressed', String(matches(lens))));
      this._lensOptions?.forEach(option => { option.selected = matches(option); });
      const kits = new Set((selected.dataset.kits || '').split(/\s+/).filter(Boolean));
      this._kits?.forEach(kit => { kit.hidden = !kits.has(kit.dataset.kit); });
      this._setMode(this._mode);
      this._setAppearance(selected);
    }

    async _setAppearance(selected) {
      if (!this._appearanceSlot) return;
      this._appearanceImages?.abort();
      this._appearanceImages = new AbortController();
      const signal = this._appearanceImages.signal;
      const current = () => this.isConnected && !signal.aborted;
      const existing = this._appearanceSlot.querySelector('img[data-le-appearance]');
      const reuse = existing?.dataset.lens === selected.dataset.leLens;
      const template = this._appearanceTemplates.find(item => item.dataset.lens === selected.dataset.leLens);
      const source = template?.content.querySelector('img[data-le-appearance]');
      this._appearanceSlot.hidden = !reuse;
      this._appearanceState('loading');
      if (!reuse && !source) {
        this._appearanceState('error');
        return;
      }
      const image = reuse ? existing : this.ownerDocument.importNode(source, true);
      if (!reuse) {
        image.removeAttribute('id');
        image.loading = 'eager';
        image.decoding = 'async';
      }
      try {
        await this._imageReady(image, signal);
        if (!current()) return;
        if (!reuse) this._appearanceSlot.replaceChildren(image);
        this._appearanceSlot.hidden = false;
        this._appearanceState('ready');
      } catch {
        if (!current()) return;
        this._appearanceSlot.hidden = true;
        this._appearanceState('error');
      }
    }

    _appearanceState(state) {
      this.dataset.appearanceStatus = state;
      this._appearanceSlot.setAttribute('aria-busy', String(state === 'loading'));
      if (!this._appearanceStatus) return;
      this._appearanceStatus.hidden = state === 'ready';
      this._appearanceStatus.textContent = state === 'ready' ? ''
        : this.dataset[state === 'error' ? 'appearanceError' : 'appearanceLoading'] || '';
    }

    _setText(selector, value) {
      this.querySelectorAll(selector).forEach(element => { element.textContent = value; });
    }

    _message(key, scene = this._activeScene) {
      this.dataset.status = key === 'error' ? 'error' : key === 'loading' ? 'loading' : 'ready';
      if (!this._status) return;
      this._status.textContent = (this.dataset[key] || '')
        .replaceAll('{scene}', scene?.dataset.label || '')
        .replaceAll('{lens}', this._lensLabel || '');
    }

    _beginRequest(scene) {
      this._images?.abort();
      this._images = new AbortController();
      this._request = (this._request || 0) + 1;
      this._pendingScene = scene;
      this._sceneLoading = true;
      this._busy(true);
      this._message('loading', scene);
      return { id: this._request, signal: this._images.signal };
    }

    _current(request) {
      return this.isConnected && !request.signal.aborted && request.id === this._request;
    }

    _busy(busy) {
      this._stage.setAttribute('aria-busy', String(busy));
      this._scenes.forEach(button => button.setAttribute('aria-busy', String(busy && button === this._pendingScene)));
      this._range.disabled = !this._hasImage;
      this.dataset.imageReady = String(this._hasImage);
    }

    async _checkInitialImages() {
      const original = this._original.querySelector('img');
      const tinted = this._tinted.querySelector('img');
      if (!original || !tinted) {
        if (this._activeScene) this._setScene(this._activeScene);
        else this._message('error');
        return;
      }
      tinted.alt = '';
      tinted.setAttribute('aria-hidden', 'true');
      this._initialImages?.abort();
      this._initialImages = new AbortController();
      const signal = this._initialImages.signal;
      const current = () => this.isConnected && !signal.aborted
        && this._original.querySelector('img') === original
        && this._tinted.querySelector('img') === tinted;
      this._pendingScene = this._activeScene;
      this._busy(true);
      this._message('loading');
      try {
        await Promise.all([this._imageReady(original, signal), this._imageReady(tinted, signal)]);
        if (!current()) return;
        this._hasImage = true;
        this._busy(this._sceneLoading);
        if (!this._sceneLoading) this._message('readyMessage');
      } catch {
        if (!current() || this._sceneLoading) return;
        this._busy(false);
        this._message('error');
      }
    }

    async _setScene(button) {
      if (this._pendingScene === button && this._stage.getAttribute('aria-busy') === 'true') return;
      if (button === this._activeScene && this._hasImage) {
        this._images?.abort();
        this._request += 1;
        this._sceneLoading = false;
        this._busy(false);
        this._message('readyMessage');
        return;
      }
      const source = button.querySelector('template[data-le-scene-template]')?.content.querySelector('img');
      if (!source) {
        this._message('error', button);
        return;
      }
      const request = this._beginRequest(button);
      const original = this.ownerDocument.importNode(source, true);
      const tinted = this.ownerDocument.importNode(source, true);
      [original, tinted].forEach(image => {
        image.removeAttribute('id');
        image.loading = 'eager';
        image.decoding = 'async';
      });
      tinted.alt = '';
      tinted.setAttribute('aria-hidden', 'true');
      try {
        await Promise.all([this._imageReady(original, request.signal), this._imageReady(tinted, request.signal)]);
        if (!this._current(request)) return;
        this._initialImages?.abort();
        this._original.replaceChildren(original);
        this._tinted.replaceChildren(tinted);
        this._activeScene = button;
        this._hasImage = true;
        this._sceneLoading = false;
        this._scenes.forEach(scene => scene.setAttribute('aria-pressed', String(scene === button)));
        this._setText('[data-le-scene-name]', button.dataset.label || '');
        this._busy(false);
        this._message('readyMessage', button);
      } catch {
        if (!this._current(request)) return;
        this._sceneLoading = false;
        this._busy(false);
        this._message('error', button);
      }
    }

    _imageReady(image, signal) {
      return new Promise((resolve, reject) => {
        let settled = false;
        let decoding = false;
        const finish = error => {
          if (settled) return;
          settled = true;
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', failed);
          signal.removeEventListener('abort', aborted);
          if (error) reject(error);
          else resolve();
        };
        const failed = () => finish(new Error('Image unavailable'));
        const aborted = () => finish(new DOMException('Aborted', 'AbortError'));
        const loaded = async () => {
          if (settled || decoding || !image.complete) return;
          if (!image.naturalWidth) {
            if (image.currentSrc || (!image.getAttribute('src') && !image.getAttribute('srcset'))) failed();
            return;
          }
          decoding = true;
          try {
            if (typeof image.decode === 'function') await image.decode();
            if (!image.complete || !image.naturalWidth) { failed(); return; }
            finish();
          } catch (error) {
            finish(error);
          }
        };
        image.addEventListener('load', loaded);
        image.addEventListener('error', failed);
        signal.addEventListener('abort', aborted, { once: true });
        if (signal.aborted) aborted();
        else queueMicrotask(loaded);
      });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
